import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ReactQueryDevtools } from 'react-query-devtools';
import { ReactQueryConfigProvider } from 'react-query';

import { QUERY_CONFIG } from '@constants/reactQuery';
import App from '@templates/App';
import { AuthProvider } from '@context/auth';

import './rootStyle.less';

const Root = () => (
  <>
    <BrowserRouter>
      <ReactQueryConfigProvider config={QUERY_CONFIG}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ReactQueryConfigProvider>
    </BrowserRouter>
    <ReactQueryDevtools initialIsOpen={false} />
  </>
);

export default Root;
